const enum TagsReportFilter {
  PROCESS_MAPS = 1,
  WORKFLOWS = 2,
  ALL = 3
}
export default TagsReportFilter;
